import { Component, output } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { AnimateComponent } from '@app/components/animate/animate.component';
import { SectionType } from '@app/models';

@Component({
  selector: 'app-top-section',
  templateUrl: './top-section.component.html',
  styleUrls: ['./top-section.component.scss'],
  imports: [NgOptimizedImage, AnimateComponent],
  standalone: true,
})
export class TopSectionComponent {
  public readonly navigationClick = output<SectionType>();
  protected readonly SectionType = SectionType;
}
